import React, { createContext, useContext, useState } from 'react';

type DataShareBulkUpdateLoadingContextType = {
  dataSharingBulkUpdateLoading: boolean;
  setDataSharingBulkUpdateLoading: (loading: boolean) => void;
};

const DataShareBulkUpdateLoadingContext = createContext<
  DataShareBulkUpdateLoadingContextType | undefined
>(undefined);

export const DataShareUpdateLoadingProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [dataSharingBulkUpdateLoading, setDataSharingBulkUpdateLoading] =
    useState(false);

  return (
    <DataShareBulkUpdateLoadingContext.Provider
      value={{
        dataSharingBulkUpdateLoading,
        setDataSharingBulkUpdateLoading,
      }}
    >
      {children}
    </DataShareBulkUpdateLoadingContext.Provider>
  );
};

export const useDataShareBulkUpdateLoading = () => {
  const context = useContext(DataShareBulkUpdateLoadingContext);
  if (context === undefined) {
    throw new Error(
      'useDataShareBulkUpdateLoading must be used within a DataShareBulkUpdateLoadingProvider',
    );
  }
  return context;
};
